// Saifi Report Line Chart

import React from "react";
import ReactECharts from "echarts-for-react";

interface SaifiReportLineChartProps {
  reportData: Array<{
    month: string;
    saifi: string;
    [key: string]: any;
  }>;
}

const SaifiReportLineChart: React.FC<SaifiReportLineChartProps> = ({
  reportData,
}) => {
  const options = {
    tooltip: {
      trigger: "axis",
      backgroundColor: "#181B25",
      borderWidth: 1,
      borderColor: "#181B25",
      formatter: (params: any) => `
          <div style="padding: 5px; color: #fff;">
            ${params[0].name}: ${params[0].value}%
          </div>
        `,
    },
    xAxis: {
      type: "category",
      data: reportData.map((item) => item.month),
      axisLabel: {
        color: "#5F6368",
      },
    },
    yAxis: {
      type: "value",
      name: "SAIFI (interruptions per consumer)",
      axisLabel: {
        formatter: "{value}",
        color: "#5F6368",
        fontSize: 9,
        fontWeight: 400,
        lineHeight: 11,
        letterSpacing: 0.2,
      },
    },
    grid: {
      left: "5%",
      right: "3%",
      bottom: "10%",
      containLabel: true,
    },
    series: [
      {
        name: "SAIDI",
        type: "line",
        data: reportData.map((item) => item.saifi),
        itemStyle: { color: "#1976d2" },
        smooth: true,
      },
    ],
  };

  return (
    <ReactECharts option={options} style={{ height: "310px", width: "100%" }} />
  );
};

export default SaifiReportLineChart;
